/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { TextFilterCell as i } from "@progress/kendo-react-data-tools";
import { localizeFilter as l, textFilterOperators as a } from "./utils.mjs";
import { useLocalization as s } from "@progress/kendo-react-intl";
const p = function(t) {
  const { operators: e, ...r } = t;
  return /* @__PURE__ */ o.createElement(
    i,
    {
      ariaLabel: "text filter",
      ...l(s(), e || a),
      ...r
    }
  );
};
export {
  p as TreeListTextFilter
};
